export const environment = {
  production: false,
  googleAnalyticsKey: 'G-GNFFTD8G4P',
  useGA: true,
  version: '1.1.0',
  build: 'Build-1.1.0.261026122211908',
  API_PATH_DR: '/dr',
  encriptPasswd: 'ABCKSoft2024!',
  appTitle: 'ABC Integral Solutions - Portal de Candidatos',
  /** Controla si el botón "Eliminar registro" es visible en historial académico y laboral */
  allowDeleteRegistro: true,
};






























